"use client";

import { motion } from "framer-motion";
import { useLanguage } from "@/lib/i18n/context";
import { pageTheme } from "@/lib/theme/page-theme";

const partnerLogos: Record<string, { dark: string; light?: string }> = {
  "MAZAK": { dark: "/media/logos/Mazak_logo.svg" },
  "BLUM-Novotest": { dark: "/media/logos/blum-novotest_logo.svg", light: "/media/logos/blum-novotest_logo_light.svg" },
};

export function PartnershipSection() {
  const { t } = useLanguage();

  return (
    <div className={pageTheme.partnershipBg}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className={pageTheme.sectionTitle}>{t.onas.partnershipsTitle}</h2>
          <p className="text-zinc-600 dark:text-zinc-400 max-w-2xl mx-auto">
            {t.onas.partnershipsDesc}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
          {t.onas.partners.map((partner, idx) => {
            const logos = partnerLogos[partner.name];
            return (
              <motion.div
                key={partner.name}
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.1 }}
                className={pageTheme.partnerCard}
              >
                <div className={pageTheme.partnerLogoBg}>
                  {logos?.light ? (
                    <>
                      <img
                        src={logos.dark}
                        alt={partner.name}
                        className="hidden dark:block w-full h-full object-contain"
                      />
                      <img
                        src={logos.light}
                        alt={partner.name}
                        className="block dark:hidden w-full h-full object-contain"
                      />
                    </>
                  ) : logos?.dark ? (
                    <img
                      src={logos.dark}
                      alt={partner.name}
                      className="w-full h-full object-contain"
                    />
                  ) : (
                    <div className="text-2xl font-black text-zinc-400 dark:text-zinc-600 tracking-tighter">
                      {partner.name}
                    </div>
                  )}
                </div>

                <div className="text-center md:text-left">
                  <div className={pageTheme.partnerBadge}>
                    {partner.role}
                  </div>
                  <h3 className="text-2xl font-bold text-zinc-900 dark:text-white mb-2">{partner.name}</h3>
                  <p className="text-zinc-600 dark:text-zinc-400 text-sm leading-relaxed">
                    {partner.desc}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
